import { samlApi } from '@/services/instance/api/samlApi';
import { optionsService } from '@/services/instance/optionsService';
import { Saml } from '@/services/saml';

export const saml = new Saml({
    samlApi,
    optionsService,
});
